import { render, staticRenderFns } from "./HouseResourceModal.vue?vue&type=template&id=be15c9c4&scoped=true"
import script from "./HouseResourceModal.vue?vue&type=script&lang=js"
export * from "./HouseResourceModal.vue?vue&type=script&lang=js"
import style0 from "./HouseResourceModal.vue?vue&type=style&index=0&id=be15c9c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be15c9c4",
  null
  
)

export default component.exports